import Swup from 'swup';
import SwupFadeTheme from '@swup/fade-theme';
import SwupBodyClassPlugin from '@swup/body-class-plugin';
import SwupProgressPlugin from '@swup/progress-plugin';
import SwupGtagPlugin from 'swup-gtag-plugin';

import common from './routes/common';
import home from './routes/home';
import participations from './routes/participations';
import single_participation from './routes/single-participation';

export default {
  init() {
    /* eslint-disable-next-line */
    $.post(ajax_object.ajax_url, {action: 'is_user_logged_in'}, function(isLogged) {
      if(!isLogged) {
        const swup = new Swup({
          plugins: [
            new SwupFadeTheme(),
            new SwupBodyClassPlugin(),
            new SwupProgressPlugin(),
            new SwupGtagPlugin({
              gaMeasurementId: 'UA-46519556-1',
            }),
          ],
          linkSelector:
            'a[href^="' +
            window.location.origin +
            '"]:not([data-no-swup]), a[href^="/"]:not([data-no-swup])',
        });

        swup.on('contentReplaced', pageInit);
      }
    });

    function pageInit() {
      $('#hamburger-toggle').off('click');
      $('#nav-primary .menu-item a').off('click');
      $('.see-more-toggle a').off('click');

      common.init();

      if($('body').hasClass('home')) {
        document.location.reload();
        home.init();
      } else if($('body').hasClass('participations')) {
        participations.init();
      } else if($('body').hasClass('single-participation')) {
        single_participation.init();
      }
    }
  },
}



// WEBPACK FOOTER //
// ./scripts/swup.js